import ComponentLayout from "../../../../src/layouts/component-layout";
import { HeadingTags, HeadingSizes, HeadingWeights, HeadingStretch, defaultHeadingTag, HeadingLetterSpacing, TextVariants, defaultTextVariant } from '@primer/react-brand';
import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  HeadingTags,
  HeadingSizes,
  HeadingWeights,
  HeadingStretch,
  defaultHeadingTag,
  HeadingLetterSpacing,
  TextVariants,
  defaultTextVariant,
  Label,
  PropTableValues,
  React
};